import { Popper, ClickAwayListener, Fade, Paper, Box, Button, createTheme, Typography, ThemeProvider } from "@mui/material";
import React, { useState } from "react";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Textarea } from "@mui/joy";
import CustomCurrencyTextField from "../../components/CustomCurrencyTextField";
import CustomTextField from "../../components/CustomTextField";
import DateSelector from "../../components/DateSelector";
import HistoryTable from "../../components/HistoryTable";
import MultiSelectPrimary from "../../components/MultiSelectPrimary";
import SelectBox from "../../components/SelectBox";
import { CssVarsProvider as JoyCssVarsProvider } from '@mui/joy/styles';
import TrainingScheduleTable from "../../components/TrainingScheduleTable";
import CompetionsTable from "../../components/CompetionsTable";
import TitlesTable from "../../components/TitlesTable";
import { setIsUpdatedTeam, setSelectedTeam } from "../../redux/reducers/dataCaptures";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { isEmpty } from "../../common/StaticExports";
import AgeGroupSelect from "../../components/AgeGroupSelect";
import StaffSelect from "../../components/StaffSelect";
import StaffMultiSelectAutocomplete from "../../components/StaffMultiSelectAutocomplete";
import GroundSelectAutocomplete from "../../components/GroundSelectAutocomplete";

const theme = createTheme({
    components: {
        MuiPaper: {
            styleOverrides: {
                root: {
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    marginTop: '7%'
                },
            }
        },
        MuiTypography: {
            styleOverrides: {
                root: {
                    fontSize: 13
                }
            }
        },
        MuiInputBase: {
            styleOverrides: {
                input: {
                    fontSize: 13
                }
            }
        },
        MuiAccordion: {
            styleOverrides: {
                root: {
                    marginTop: 0
                }
            }
        }
    }
})
const competitionHead = [
    {
      key: '', displayName: 'Club Name',
    },
    {
        key: '', displayName: 'From year',
    },
    {
        key: '', displayName: 'To year',
    },
    {
        key: '', displayName: '',
    },
  ]

const coachingHead = [
{
    key: '', displayName: 'Club Name',
},
{
    key: '', displayName: 'From year',
},
{
    key: '', displayName: 'To year',
},
{
    key: '', displayName: '',
},
]

const TeamDetailPage = (props:any) => {
    const { isOpen, handleClose } = props;
    const [addCompetitions, setAddCompetitions] = useState(false);
    const [addTitles, setAddTitles] = useState(false);
    const selectedTeam = useSelector((state:any) => state.dataCaptures.selectedTeam);
    const teamDetails = selectedTeam?.teamDetails || {};
    const playerAges = selectedTeam?.playerAges || {};
    const teamFees = selectedTeam?.teamFees || {};
    const dispatch = useDispatch();
    const [t] = useTranslation();
    const isAdmin = useSelector((state:any) => state.common.isAdmin);

    const updateState = ((mainKey:any, key:any, updatedData:any) => {
        let updatedStaff:any = {};
        if (key == null) {
            updatedStaff = {
                ...selectedTeam,
                [mainKey]: updatedData,
            };
        } else {
            updatedStaff = {
                ...selectedTeam,
                [mainKey]: {
                    ...selectedTeam[mainKey],
                    [key]: updatedData,
                },
            };
        }
        dispatch(setSelectedTeam(updatedStaff));
        const boolean:any = true;
        dispatch(setIsUpdatedTeam(boolean));
    });

    return (
            <React.Fragment>
                <ThemeProvider theme={theme}>
                <Popper className='popperStyle' open={isOpen} transition>
                        {({ TransitionProps }) => (
                <ClickAwayListener onClickAway={handleClose}>
                    <Fade {...TransitionProps} timeout={350}>
                                <Paper sx={{ p: 2, width: '1200px', mt: '20px', height: '650px', overflowY: 'auto' }}>
                                    <Box  className='mb20'>
                                        <Typography className='standardsHeading uppercase'>{t('DC_7_TEAM_DETAILS')}</Typography>
                                        <Box className='teamDetailsStyles'>
                                            <CustomTextField label={t('DC_7_NAME')} value={teamDetails?.teamName} manageChange={(e:any) => { updateState('teamDetails', 'teamName', e) }} errorMessage={t('REQUIRED')} isError={isEmpty(teamDetails?.teamName) && !isAdmin} isDisabled={isAdmin} />
                                            <CustomTextField type={'number'} label={t('DC_7_ESTABLISHED')} value={teamDetails?.established} manageChange={(e:any) => { updateState('teamDetails', 'established', parseInt(e)) }} errorMessage={t('REQUIRED')} isError={isEmpty(teamDetails?.established) && !isAdmin} isDisabled={isAdmin} />
                                            <AgeGroupSelect 
                                            label={t('DC_7_AGE_GROUP')} 
                                            value={teamDetails?.ageGroup ? teamDetails?.ageGroup : ''}
                                            manageSelect={(e:any) => { updateState('teamDetails', 'ageGroup', e) }}
                                            isError={isEmpty(teamDetails?.ageGroup)}
                                            errorMessage={t('REQUIRED')} 
                                            isReadOnly={isAdmin}/>
                                            <StaffSelect 
                                            value={teamDetails?.staffSupervisor ? teamDetails?.staffSupervisor : ''}
                                            manageSelect={(e:any) => { updateState('teamDetails', 'staffSupervisor', e) }}
                                            label={t('DC_7_STAFF_SUPERVISOR')}
                                            isError={isEmpty(teamDetails?.staffSupervisor)}
                                            errorMessage={t('REQUIRED')}
                                            isReadOnly={isAdmin}/>
                                            <StaffMultiSelectAutocomplete 
                                            selectedValues={teamDetails?.staffCoaches ? teamDetails?.staffCoaches : []}
                                            manageSelect={(e:any) => { updateState('teamDetails', 'staffCoaches', e) }}
                                            label={t('DC_7_STAFF_COACHES')} isReadOnly={isAdmin}/>
                                            <StaffMultiSelectAutocomplete 
                                            selectedValues={teamDetails?.staffGkCoaches ? teamDetails?.staffGkCoaches : []}
                                            manageSelect={(e:any) => { updateState('teamDetails', 'staffGkCoaches', e) }}
                                            label={t('DC_7_STAFF_GK_COACHES')} isReadOnly={isAdmin}/>
                                            <StaffMultiSelectAutocomplete 
                                            selectedValues={teamDetails?.medicalStaff ? teamDetails?.medicalStaff : []}
                                            manageSelect={(e:any) => { updateState('teamDetails', 'medicalStaff', e) }}
                                            label={t('DC_7_MEDICAL_STAFF')} isReadOnly={isAdmin}/>
                                            <GroundSelectAutocomplete 
                                            selectedValues={teamDetails?.practiceGrounds ? teamDetails?.practiceGrounds : []}
                                            manageSelect={(e:any) => { updateState('teamDetails', 'practiceGrounds', e) }}
                                            label={t('DC_7_PRACTICE_GROUNDS')} isReadOnly={isAdmin}/>
                                        </Box>
                                    </Box>
                                    <Box  className='mb20'>
                                        <Typography className='standardsHeading uppercase'>{t('DC_7_PLAYER_AGES')}</Typography>
                                        <Box className='noPlayersStyles'>
                                            <CustomTextField type={'number'} label='U-18' value={playerAges?.u18} manageChange={(e:any) => { updateState('playerAges', 'u18', parseInt(e)) }} isDisabled={isAdmin} />
                                            <CustomTextField type={'number'} label='U-17' value={playerAges?.u17} manageChange={(e:any) => { updateState('playerAges', 'u17', parseInt(e)) }} isDisabled={isAdmin} />
                                            <CustomTextField type={'number'} label='U-16' value={playerAges?.u16} manageChange={(e:any) => { updateState('playerAges', 'u16', parseInt(e)) }} isDisabled={isAdmin} />
                                            <CustomTextField type={'number'} label='U-15' value={playerAges?.u15} manageChange={(e:any) => { updateState('playerAges', 'u15', parseInt(e)) }} isDisabled={isAdmin} />
                                            <CustomTextField type={'number'} label='U-14' value={playerAges?.u14} manageChange={(e:any) => { updateState('playerAges', 'u14', parseInt(e)) }} isDisabled={isAdmin} />
                                            <CustomTextField type={'number'} label='U-13' value={playerAges?.u13} manageChange={(e:any) => { updateState('playerAges', 'u13', parseInt(e)) }} isDisabled={isAdmin} />
                                            <CustomTextField type={'number'} label='U-12' value={playerAges?.u12} manageChange={(e:any) => { updateState('playerAges', 'u12', parseInt(e)) }} isDisabled={isAdmin} />
                                            <CustomTextField type={'number'} label='U-11' value={playerAges?.u11} manageChange={(e:any) => { updateState('playerAges', 'u11', parseInt(e)) }} isDisabled={isAdmin} />
                                            <CustomTextField type={'number'} label='U-10' value={playerAges?.u10} manageChange={(e:any) => { updateState('playerAges', 'u10', parseInt(e)) }} isDisabled={isAdmin} />
                                            <CustomTextField type={'number'} label='U-9' value={playerAges?.u9} manageChange={(e:any) => { updateState('playerAges', 'u9', parseInt(e)) }} isDisabled={isAdmin} />
                                        </Box>
                                    </Box>
                                    <Box  className='mb20'>
                                        <Typography className='standardsHeading uppercase'>{t('DC_7_TRAINING_SCHEDULE')}</Typography>
                                        <Box>
                                            <TrainingScheduleTable
                                            manageChange={(e:any) => { updateState('trainingSchedule', null, e) }} />
                                        </Box>
                                    </Box>
                                    <Box  className='mb20'>
                                        <Typography className='standardsHeading uppercase'>{t('DC_7_TEAM_FEES')}</Typography>
                                        <Box className='teamFeeStyles'>
                                            <CustomCurrencyTextField label={'ADMISSION FEES (¥)'} variant='outlined' value={teamFees?.admissionFees} manageChange={(d:any) => updateState('teamFees','admissionFees', d)} isReadOnly={isAdmin}/>
                                            <CustomCurrencyTextField label={'PLAYER MONTHLY EXPENSES (¥)'} variant='outlined' value={teamFees?.playerMonthlyExpense} manageChange={(d:any) => updateState('teamFees','playerMonthlyExpense', d)} isReadOnly={isAdmin}/>
                                            <CustomCurrencyTextField label={'TRAVEL MONTHLY EXPENSES (¥)'} variant='outlined' value={teamFees?.travelMonthlyExpense} manageChange={(d:any) => updateState('teamFees','travelMonthlyExpense', d)} isReadOnly={isAdmin}/>
                                            <CustomTextField label='Remarks' value={teamFees?.remarks} manageChange={(e:any) => { updateState('teamFees', 'remarks', e) }} isDisabled={isAdmin} />
                                        </Box>
                                    </Box>
                                    <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                                        <Box  className='mb20' sx={{ width: '45%' }}>
                                            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                                                <Typography className='standardsHeading uppercase'>{t('DC_7_LY_COMPETITIONS')}</Typography>
                                                {
                                                    !isAdmin &&
                                                    <Button className='smallButton' sx={{ float: 'right' }} disableElevation disabled={addCompetitions} variant='contained' size='small' onClick={() => {setAddCompetitions(true)}} startIcon={<FontAwesomeIcon icon={faPlus} />}>
                                                        {'Add competition'}
                                                    </Button>
                                                }
                                            </Box>
                                            <Box>
                                                <CompetionsTable 
                                                addData={addCompetitions} 
                                                handleClick={() => setAddCompetitions(false)}
                                                manageState={(e:any) => { updateState('competitions', null, e) }} />
                                            </Box>
                                        </Box>
                                        <Box  className='mb20' sx={{ width: '45%' }}>
                                            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                                                <Typography className='standardsHeading uppercase'>{t('DC_7_TITLES')}</Typography>
                                                {
                                                    !isAdmin &&
                                                    <Button className='smallButton' sx={{ float: 'right' }} disableElevation disabled={addTitles} variant='contained' size='small' onClick={() => {setAddTitles(true)}} startIcon={<FontAwesomeIcon icon={faPlus} />}>
                                                        {'Add title'}
                                                    </Button>
                                                }
                                            </Box>
                                            <Box>
                                                <TitlesTable 
                                                addData={addTitles}
                                                handleClick={() => setAddTitles(false)}
                                                manageState={(e:any) => { updateState('titles', null, e) }}/>
                                            </Box>
                                        </Box>
                                    </Box>
                                </Paper>
                            </Fade>
                        </ClickAwayListener>
                        )}
                    </Popper>
                </ThemeProvider>
            </React.Fragment>
    )
}

export default TeamDetailPage;